import React from 'react';
import { Container, Row, Col, Button, Card, Badge } from 'react-bootstrap';

function BulkPurchaseSection() {
  const ADS = [
    {
      title: 'Kamsiparts',
      tag: 'Auto Parts',
      blurb: 'Powering mobility with genuine auto parts sourcing and distribution.',
      href: 'https://kamsiparts.com/oximo-product/',
      abbr: 'KP',
      cta: 'Shop Auto Parts',
    },
    {
      title: 'KambiHome',
      tag: 'Lifestyle',
      blurb: 'Simplifying lifestyle with trusted home and living solutions.',
      href: 'https://kambihome.com',
      abbr: 'KH',
      cta: 'Explore Home',
    },
    {
      title: 'Kambi3PL',
      tag: 'Logistics',
      blurb: 'Delivering efficiency with smart logistics and last-mile fulfillment.',
      href: 'https://kambi3pl.com',
      abbr: '3PL',
      cta: 'Start Shipping',
    },
    {
      title: 'MazesAI',
      tag: 'AI & Data',
      blurb: 'Driving intelligence with AI-powered data and automation.',
      href: 'https://mazesai.com',
      abbr: 'AI',
      cta: 'Discover MazesAI',
    },
  ];

  return (
    <>
      {/* Hero CTA */}
      <Row
        className="justify-content-center my-5"
        style={{ color: 'white', backgroundColor: 'rgb(35, 35, 199)', padding: '50px' }}
      >
        <Col xs={12} md={8} lg={6} className="text-center">
          <h2>Do you need bulk purchase from Kamsiparts Automotive?</h2>
          <p>Order in Bulk now</p>
          <Button
            variant="light"
            href="https://app.kamsiparts.com/bulk-products-requests/"
            className="fw-semibold"
            style={{ cursor: 'pointer' }}
          >
            Order Now
          </Button>
        </Col>
      </Row>

      {/* Sponsored Ad Section */}
      <section className="my-5">
        <Container>
          <Row className="justify-content-center text-center">
            <Col xs={12}>
              <Badge bg="secondary" className="mb-2 px-3 py-1" style={{ fontSize: '0.85rem' }}>
                Sponsored
              </Badge>
              <h2 className="fw-bold">TCHIKAMALOR Global Ecosystem Platforms</h2>
              <p className="lead text-muted mb-4">
                One Ecosystem. Multiple Solutions. Unified Purpose.
              </p>
            </Col>
          </Row>

          <Row className="justify-content-center g-4">
            {ADS.map((ad) => (
              <Col key={ad.title} xs={6} md={4} lg={3}>
                <a
                  href={ad.href}
                  className="text-decoration-none"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`${ad.title} - ${ad.tag}`}
                  style={{ cursor: 'pointer' }}
                >
                  <Card className="adx h-100">
                    <div className="adx-hero ratio ratio-16x9 d-flex align-items-center justify-content-center">
                      <span className="adx-abbr">{ad.abbr}</span>
                    </div>

                    <Card.Body className="d-flex flex-column">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <Card.Title className="mb-0">{ad.title}</Card.Title>
                        <Badge bg="light" text="dark">{ad.tag}</Badge>
                      </div>

                      <Card.Text className="text-muted flex-grow-1">{ad.blurb}</Card.Text>

                      <div className="pt-2">
                        <Button variant="primary" className="w-100 fw-semibold" style={{ cursor: 'pointer' }}>
                          {ad.cta}
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </a>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Styles */}
      <style>{`
        .adx {
          position: relative;
          border: 0;
          box-shadow: 0 12px 36px rgba(0,0,0,0.12);
          transition: transform .25s ease, box-shadow .25s ease;
          overflow: hidden;
          background-clip: padding-box;
        }
        .adx::before {
          content: "";
          position: absolute;
          inset: 0;
          padding: 1px;
          border-radius: .5rem;
          background: linear-gradient(135deg, rgba(35,99,255,0.35), rgba(35,199,160,0.35));
          -webkit-mask: 
            linear-gradient(#000 0 0) content-box, 
            linear-gradient(#000 0 0);
          -webkit-mask-composite: xor;
                  mask-composite: exclude;
          pointer-events: none;
        }
        .adx:hover {
          transform: translateY(-4px) scale(1.05);
          box-shadow: 0 20px 50px rgba(0,0,0,0.18);
        }
        .adx .btn {
          transition: transform .2s ease, box-shadow .2s ease;
        }
        .adx:hover .btn {
          transform: translateY(-1px);
          box-shadow: 0 10px 24px rgba(49,132,253,0.35);
        }

        .adx-hero {
          background:
            radial-gradient(120% 120% at 100% 0%, rgba(49,132,253,0.20) 0%, rgba(49,132,253,0) 60%),
            linear-gradient(135deg, #f8f9fa 0%, #eef3ff 100%);
          border-bottom: 1px solid rgba(0,0,0,0.06);
          position: relative;
          overflow: hidden;
        }
        .adx-hero::after {
          content: "";
          position: absolute;
          top: 0; left: -40%;
          width: 60%;
          height: 100%;
          transform: skewX(-20deg);
          background: linear-gradient(90deg, transparent, rgba(255,255,255,.6), transparent);
          opacity: 0;
          transition: opacity .3s ease, left .6s ease;
        }
        .adx:hover .adx-hero::after {
          opacity: 1;
          left: 120%;
        }

        .adx-abbr {
          font-weight: 900;
          font-size: clamp(1.2rem, 3.2vw, 1.9rem);
          letter-spacing: .06em;
          color: rgba(0,0,0,0.65);
          text-transform: uppercase;
        }
      `}</style>
    </>
  );
}

export default BulkPurchaseSection;
